<template>
    <button
    class="
      mx-1
      inline-flex
      items-center
      p-1
      border 
      border-transparent
      rounded-full
      text-gray-500
      focus:outline-none 
      focus:ring-1 
      focus:ring-offset-1
    "
    :class="[deleteBtn ? 'focus:ring-red-400' : 'focus:ring-blue-400']">
        <EyeIcon v-if="editBtn" class="p-0.5 h-6 w-6 text-gray-500" />
        <XMarkIcon v-else-if="closeBtn" class="p-0.5 h-6 w-6 text-gray-500" />
        <TrashIcon v-else-if="deleteBtn" class="p-0.5 h-6 w-6 text-red-500" />
        <ArrowPathIcon v-else-if="restoreBtn" class="p-0.5 h-6 w-6 text-green-500" />
  </button>
</template>

<script setup lang="ts">
import { EyeIcon, TrashIcon, XMarkIcon, ArrowPathIcon } from "@heroicons/vue/24/outline";

defineProps({
    editBtn: {
        type: Boolean,
    },
    deleteBtn: {
        type: Boolean,
    },
    closeBtn: {
        type: Boolean,
    },
    restoreBtn: {
        type: Boolean,
    }
});

</script>
